"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateInputTranslation = exports.placeholder = exports.maxRows = exports.overlay = exports.clearfix = exports.breakpoint = exports.inputHeight = void 0;
const theme_1 = __importDefault(require("./theme"));
function inputHeight(height) {
    return {
        '& *.rfc-input': {
            height: height,
            lineHeight: `${height * 2 / 3}px`,
            paddingTop: height / 6,
            paddingBottom: height / 6,
            '&[type=file]': {
                lineHeight: `${height * 0.45}px`,
            },
        },
        '& textarea.rfc-input': {
            minHeight: height,
            height: 'auto',
        },
        '& .rfc-select:not([multiple])': {
            backgroundPosition: `calc(100% - 15px) ${height / 2 - 2}px, calc(100% - 10px) ${height / 2 - 2}px`,
        },
        '& $prefix, & $suffix': {
            height,
            lineHeight: `${height}px`,
        },
        '&$inlineLabel > $label': {
            [breakpoint(theme_1.default.breakpoints.sm)]: {
                lineHeight: `${height}px`,
                marginBottom: 0,
            },
        },
        '&$inlineLabel .rfc-checkitem:first-child': {
            marginTop: height / 6,
        },
    };
}
exports.inputHeight = inputHeight;
function breakpoint(width) {
    return `@media (min-width: ${width})`;
}
exports.breakpoint = breakpoint;
function clearfix() {
    return {
        '&:after': {
            content: '',
            display: 'table',
            clear: 'both',
        },
    };
}
exports.clearfix = clearfix;
function overlay() {
    return {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 100,
    };
}
exports.overlay = overlay;
function maxRows(amount) {
    return {
        overflow: 'hidden',
        display: '-webkit-box',
        '-webkit-line-clamp': amount || 1,
        '-webkit-box-orient': 'vertical',
    };
}
exports.maxRows = maxRows;
function placeholder(styles) {
    return {
        '&::-moz-placeholder': Object.assign({}, styles),
        '&:-ms-input-placeholder': Object.assign({}, styles),
        '&::-webkit-input-placeholder': Object.assign({}, styles),
    };
}
exports.placeholder = placeholder;
function calculateInputTranslation(fontSize, inputSize) {
    return `translateY(${(fontSize / 2) - (inputSize / 2 - 2)}px)`;
}
exports.calculateInputTranslation = calculateInputTranslation;
